import { LogLevel } from "@azure/msal-browser";

export const apiUrl: string = (window.location.href.includes('team-tracker') ? import.meta.env.VITE_TEAMS_API_URL : import.meta.env.VITE_API_URL) ?? '';
export const uiUrl: string = (window.location.href.includes('team-tracker') ? import.meta.env.VITE_TEAMS_UI_URL : import.meta.env.VITE_UI_URL) ?? '';
// Tenant URL admins paste into Entra ID provisioning; same host for team-tracker and team-today.
export const scimUrl: string = import.meta.env.VITE_SCIM_URL ?? '';

export const stripeProductMonthlyPriceId_USD: string = import.meta.env.VITE_PRODUCT_MONTHLY_PRICE_ID_USD ?? '';
export const stripeProductMonthlyPriceId_GBP: string = import.meta.env.VITE_PRODUCT_MONTHLY_PRICE_ID_GBP ?? '';
export const stripeProductMonthlyPriceId_EUR: string = import.meta.env.VITE_PRODUCT_MONTHLY_PRICE_ID_EUR ?? '';
export const stripeProductMonthlyPriceId_AUD: string = import.meta.env.VITE_PRODUCT_MONTHLY_PRICE_ID_AUD ?? '';

export const stripeProductYearlyPriceId_USD: string = import.meta.env.VITE_PRODUCT_YEARLY_PRICE_ID_USD ?? '';
export const stripeProductYearlyPriceId_GBP: string = import.meta.env.VITE_PRODUCT_YEARLY_PRICE_ID_GBP ?? '';
export const stripeProductYearlyPriceId_EUR: string = import.meta.env.VITE_PRODUCT_YEARLY_PRICE_ID_EUR ?? '';
export const stripeProductYearlyPriceId_AUD: string = import.meta.env.VITE_PRODUCT_YEARLY_PRICE_ID_AUD ?? '';

// Premium tier price IDs (must match stripe.premium.price-ids on the backend)
export const stripePremiumProductMonthlyPriceId_USD: string = import.meta.env.VITE_PREMIUM_PRODUCT_MONTHLY_PRICE_ID_USD ?? '';
export const stripePremiumProductMonthlyPriceId_GBP: string = import.meta.env.VITE_PREMIUM_PRODUCT_MONTHLY_PRICE_ID_GBP ?? '';
export const stripePremiumProductMonthlyPriceId_EUR: string = import.meta.env.VITE_PREMIUM_PRODUCT_MONTHLY_PRICE_ID_EUR ?? '';
export const stripePremiumProductMonthlyPriceId_AUD: string = import.meta.env.VITE_PREMIUM_PRODUCT_MONTHLY_PRICE_ID_AUD ?? '';

export const stripePremiumProductYearlyPriceId_USD: string = import.meta.env.VITE_PREMIUM_PRODUCT_YEARLY_PRICE_ID_USD ?? '';
export const stripePremiumProductYearlyPriceId_GBP: string = import.meta.env.VITE_PREMIUM_PRODUCT_YEARLY_PRICE_ID_GBP ?? '';
export const stripePremiumProductYearlyPriceId_EUR: string = import.meta.env.VITE_PREMIUM_PRODUCT_YEARLY_PRICE_ID_EUR ?? '';
export const stripePremiumProductYearlyPriceId_AUD: string = import.meta.env.VITE_PREMIUM_PRODUCT_YEARLY_PRICE_ID_AUD ?? '';

const stripePublicKey: string = import.meta.env.VITE_STRIPE_PK ?? '';
const stripeUserPackPrice: number = parseInt(import.meta.env.VITE_USER_PACK_PRICE ?? '0');
const stripeBasePrice: number = parseInt(import.meta.env.VITE_BASE_PRICE ?? '0');
export const stripeMinUserLimit: number = parseInt(import.meta.env.VITE_MIN_USER_LIMIT ?? '0');
export const stripePackSize: number = parseInt(import.meta.env.VITE_PACK_SIZE ?? '0');
export const stripeUserLimit: number = parseInt(import.meta.env.VITE_USER_LIMIT ?? '0');
export const paymentsEnabled: boolean = import.meta.env.VITE_PAYMENTS_ENABLED === 'true';
export const publicApiKeyEnabled: boolean = import.meta.env.VITE_PUBLIC_API_KEY_ENABLED === 'true';
const showNewUserOnboardingButton: boolean = import.meta.env.VITE_NEW_USER_ONBOARDING_BUTTON === 'true';
const showMultipleWhereaboutsViews: boolean = import.meta.env.VITE_WHEREABOUTS_VIEWS === 'true';

const calendarS3Bucket: string = import.meta.env.VITE_S3_CALENDAR_BUCKET ?? '';
const followedTeamsLimit: number = parseInt(import.meta.env.VITE_FOLLOWED_TEAMS_LIMIT ?? '6');

export const enableStripe: boolean = import.meta.env.VITE_ENABLE_STRIPE === 'true';

export const microsoftClientId: string = import.meta.env.VITE_MICROSOFT_CLIENT_ID ?? '';
export const googleClientId: string = import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '';

export const recaptchaEnabled: boolean = import.meta.env.VITE_RECAPTCHA_ENABLED === 'true';

export const buildNumber: string = import.meta.env.VITE_BUILD ?? 'dev';

export const teamsTabs: any = {
  settings: 'teamsapp-team-tracker-settings',
  team: 'teamsapp-team-tracker-team',
  company: 'teamsapp-team-tracker-company',
  planner: 'teamsapp-team-tracker-planner',
  holidays: 'teamsapp-team-tracker-holidays',
  meetingRooms: 'teamsapp-team-tracker-meetingrooms',
}

export const microsoftRequest = {
  register: {
    scopes: ["email", "User.Read", "profile", "openid", "offline_access"],
    redirectUri: `${window.location.origin}/register/azure`,
  },
  login: {
    scopes: ["email", "User.Read", "profile", "openid", "offline_access"],
    redirectUri: `${window.location.origin}/login/azure`,
  },
  calendarScopes: ["email", "User.Read", "profile", "openid", "offline_access", "Calendars.ReadWrite", "MailboxSettings.Read"],
}

export const msalConfig = {
  auth: {
    clientId: microsoftClientId, // This is the ONLY mandatory field that you need to supply.
    authority: "https://login.microsoftonline.com/common", // Defaults to "https://login.microsoftonline.com/common"
    redirectUri: window.location.origin, // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    postLogoutRedirectUri: window.location.origin, // Indicates the page to navigate after logout.
    // navigateToLoginRequestUrl moved to handleRedirectPromise() options in MSAL v5.
    // Configured in msalInstance.ts initializeMsalInstance().
  },
  cache: {
    cacheLocation: "localStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    iframeHashTimeout: 10000,       // hash response from iframe (default 6 s)
    loadFrameTimeout: 10000,        // iframe load (default 0 → uses iframeHashTimeout)
    windowHashTimeout: 60000,       // popup hash timeout
    tokenRenewalOffsetSeconds: 300, // refresh 5 min before expiry, not 30 s
    loggerOptions: {
      piiLoggingEnabled: true,
      loggerCallback: (level: any, message: any, containsPii: any) => {
        // if (containsPii) {
        //   return;
        // }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            return;
          case LogLevel.Verbose:
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
        }
      }
    }
  }
};
